'use client'

import { Builder } from '@builder.io/react'

import { PartnerModule } from './PartnerModule'
import { defaultProps } from './PartnerModule.defaults'

Builder.registerComponent(PartnerModule, {
  name: 'PartnerModule',
  noWrap: true,
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: defaultProps.title,
      localized: true,
    },
    {
      name: 'description',
      type: 'string',
      defaultValue: defaultProps.description,
      localized: true,
    },
    {
      name: 'successLine1',
      type: 'string',
      defaultValue: defaultProps.successLine1,
      localized: true,
    },
    {
      name: 'successLine2',
      type: 'string',
      defaultValue: defaultProps.successLine2,
      localized: true,
    },
    {
      name: 'ctaText',
      type: 'string',
      defaultValue: defaultProps.ctaText,
      localized: true,
    },
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: defaultProps.backgroundImage,
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: defaultProps.backgroundColor,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/users-plus.svg',
})
